import styled from "styled-components";


export const CardWrapper = styled.div`
display: flex;
justify-content: space-evenly;
`

export const CardTitle = styled.div`
// text-align:center;
font-size:11px;
color: #606060;
padding:10px;
`
export const CardValue = styled.div`
// font-family: Mars Centra;
font-size: 16px;
font-weight: 700;
// line-height: 33.8px;
// text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
paading:"0px 10px"
`